export function validate(record) {
    const errors = [];

    if (!record.name || record.name.trim() === "") {
        errors.push({ field: 'name', message: 'O nome do padrão de pallet é obrigatório!' });
    }

    if (!record.height || record.height === "" || record.height <= 0) {
        errors.push({ field: 'height', message: 'A altura do padrão de pallet é obrigatória' });
    }

    if (!record.width || record.width === "" || record.width <= 0) {
        errors.push({ field: 'width', message: 'A largura do padrão de pallet é obrigatória' });
    }
    
    if (!record.depth || record.depth === "" || record.depth <= 0) {
        errors.push({ field: 'depth', message: 'A profundidade do padrão de pallet é obrigatória' });
    }

    if (!record.maxWeight || record.maxWeight === "" || record.maxWeight <= 0) {
        errors.push({ field: 'maxWeight', message: 'O peso máximo do padrão de pallet é obrigatória' });
    }

    if (!record.maxHeight || record.maxHeight === "" || record.maxHeight <= 0) {
        errors.push({ field: 'maxWeight', message: 'A altura máxima do padrão de pallet é obrigatória' });
    }

    const result = {
        ok: errors.length === 0,
        errors,
        record
    }

    return new Promise((resolve, reject) => {
        const action = result.ok ? resolve : reject;
        return action(result);
    })
}